import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    comparable: Number,
    inputName: String
  };

  static targets = ['input', 'toggle'];

  readonly inputTargets: HTMLInputElement[];
  readonly toggleTargets: HTMLElement[];
  readonly comparableValue: number;

  connect() {
    this.update();
  }

  update() {
    const selected = this.inputTargets.find(input => input.checked);

    if (!selected) return;

    const selectedValue = selected.value;
    const reference = this.comparableValue;

    this.toggleTargets.forEach((element) => {
      const valuesAttr = element.dataset.exclusiveToggleValues;
      const thresholdAttr = element.dataset.exclusiveToggleThreshold;

      if (!valuesAttr || !thresholdAttr) return;

      const values = valuesAttr.split(',').map(v => v.trim());
      const threshold = parseFloat(thresholdAttr);

      const shouldShow = values.includes(selectedValue) && reference > threshold;
      element.classList.toggle('hidden', !shouldShow);
    });
  }
}